/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { GET_POLICY_LIST } from '@pages/ActualPage/api/graphql';
import { actualListConfig } from '../../config/actualLists.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/ActualPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';
const lookup = require('country-code-lookup');
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IActualListPluginMethods extends IPluginMethodMap {
  getActualListSync(args: IGetCredentialIssuedListProps): Promise<any>;
}

export class ActualListPlugin implements IAgentPlugin {
  readonly methods: IActualListPluginMethods;

  constructor() {
    this.methods = {
      getActualListSync: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    return await this.getAppCardList(args);
    // return {
    //   ActualList:actualListConfig
    //  };
  }

  private async getAppCardList(args: IGetCredentialIssuedListProps) {
    let _where1 = args?.where?.filter(
      (item: any) => item?.column === 'policyNumber'
    );
    let _where2 = args?.where?.filter(
      (item: any) => item?.column !== 'policyNumber'
    );
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_POLICY_LIST, {
          input: {
            skip: args?.offset ?? 0,
            limit: args?.size ?? 10,
            where: [..._where1],
            order: [
              {
                column: 'purchasedAt',
                direction: 'DESC',
              },
            ],
            relationFilter: {
              purchasedBy: {
                where: [..._where2],
                limit: args?.size ?? 10,
                skip: args?.offset ?? 0,
              },
            },
          },
        })
        .toPromise();
      if (res?.data) {
        console.log(`table data`, res);
        let _rowData = this.formatTable(res?.data?.getListOfPolicies?.data);
        return {
          ...actualListConfig,
          ultUsers: _rowData,
          isEmpty: res?.data?.getListOfPolicies?.data?.length <= 0,
          // studentGroup: holderGroups,
          activePage: res?.data?.getListOfPolicies?.currentPage,
          pageSize: res?.data?.getListOfPolicies?.pageSize,
          totalCount: res?.data?.getListOfPolicies?.totalCount,
          totalPages: res?.data?.getListOfPolicies?.totalPages,
        };
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }
  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          country:
            item?.purchasedBy?.country &&
            item?.purchasedBy?.country.length === 2
              ? lookup.byIso(`${item?.purchasedBy?.country}`)?.country
              : '-',
          countryCode: item?.purchasedBy?.country,
          vid: item?.purchasedBy?.vuid,
          policyNo: item?.policyNumber,
          status: item?.status,
          name: `${toHeaderCase(
            item?.purchasedBy?.firstName ?? ''
          )} ${toHeaderCase(item?.purchasedBy?.lastName ?? '')}`,
          email: item?.purchasedBy?.email,
          // image:item?.image,
          dateCreated: item?.purchasedAt
            ? moment(item?.purchasedAt).format('LLL')
            : '-',
          coverage: item?.coverage,
          premium: item?.premium,
          discount:
            item?.discountedPremium && item?.discountedPremium !== item?.premium
              ? item?.discountedPremium
              : 'NA',
          //discount:item?.discountedPremium,
          policyOption: `Policy Option ${item?.policyOption}`,
        };
      });
    return _rowData;
  }
}
